import React from 'react'
import Moment from 'react-moment';
import 'moment/locale/es';

export const DocumentDate = ({ date }) => {

  return date && (
    <small className="text-muted">
      <span>Ultima actualizaci&oacute;n hace: 
        <Moment className="ml-1 font-weight-bold" fromNow ago>
          {date}
        </Moment>
      </span>
    </small>
  )
}